export interface departmentsClass{
    AccountDepartmentId: number
    AccountId: number
    DepartmentCode: string
    DepartmentName: string
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
    CustomField1: string
    CustomField2: string
    CustomField3: string
    CustomField4: string
    CustomField5: string
    CustomField6: string
    CustomField7: string
    CustomField8: string
    CustomField9: string
    CustomField10: string
    CustomField11: string
    CustomField12: string
    CustomField13: string
    CustomField14: string
    CustomField15: string
    AccountWorkingDayTypeId:string
    AccountTimeOffPolicyId:string

}

export const departmentsInitialsForAdd={
    DepartmentCode: "",
    DepartmentName: "",
    CustomField1: '',
    CustomField2: '',
    CustomField3: '',
    CustomField4: '',
    CustomField5: '',
    CustomField6: '',
    CustomField7: '',
    CustomField8: '',
    CustomField9: '',
    CustomField10: '',
    CustomField11: '',
    CustomField12: '',
    CustomField13: '',
    CustomField14: '',
    CustomField15: '',
    AccountWorkingDayTypeId:'00000000-0000-0000-0000-000000000000',
    AccountTimeOffPolicyId:'00000000-0000-0000-0000-000000000000',
    IsDisabled: false
}

export const departmentInitialsForUpdate = {
    DepartmentCode: "",
    DepartmentName: "",
    AccountDepartmentId:"",
    CustomField1: '',
    CustomField2: '',
    CustomField3: '',
    CustomField4: '',
    CustomField5: '',
    CustomField6: '',
    CustomField7: '',
    CustomField8: '',
    CustomField9: '',
    CustomField10: '',
    CustomField11: '',
    CustomField12: '',
    CustomField13: '',
    CustomField14: '',
    CustomField15: '',
    AccountWorkingDayTypeId:'00000000-0000-0000-0000-000000000000',
    AccountTimeOffPolicyId:'00000000-0000-0000-0000-000000000000',
    IsDisabled: false
}